/* written by katalog-motoru/sync.py from katalog.json: how the shared viewer runs this book (README there) */
window.KATALOG = {"ns": "MP", "key": "mp", "langs": ["tr", "en"], "hash": ["VERSION", "content", "products", "sets", "chapters"]};
